import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Pipe({
  name: 'inspectionType'
})
export class InspectionTypePipe implements PipeTransform {
  constructor(private service: ConfigurationService) {}

  transform(inspectionTypeId: number): string {
    const item = this.service.inspectionTypes.find(
      (type) => type.id === inspectionTypeId
    );

    return item ? item.name : '';
  }
}
